// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16RvI","label":"styles_label__1tQJZ"};